import { connect } from "react-redux";
import { useMountEffect } from "primereact/hooks";
import { useIntl } from "react-intl";
import { compliancePassportRequest } from "../../../store/slices/selfSlice";
import Section from "../../common/section";
import PassportImage from "../../../assets/images/completed_badge_rectangle.png";
import ExpiredPassportImage from "../../../assets/images/expired_badge_rectangle.png";
import "./compliance-passport.scss";
import dayjs from "dayjs";

const CompliancePassportWidget = ({
  compliancePassportRequest,
  compliancePassport,
}) => {
  const intl = useIntl();

  useMountEffect(() => {
    compliancePassportRequest();
  }, []);

  return (
    <Section title="compliance_passport" className="edelxms-widget">
      {(compliancePassport.filter((passport) => {
        return (
          !passport.learningPathway.isRepetable ||
          dayjs(passport.completionDate).add(
            passport.learningPathway.repetableInMonths,
            "month"
          ) >= dayjs()
        );
      }).length > 0 && (
        <div className="flex gap-4">
          {compliancePassport.map((passport) => {
            const isExpired =
              (passport.learningPathway.isRepetable &&
                dayjs(passport.completionDate).add(
                  passport.learningPathway.repetableInMonths,
                  "month"
                ) < dayjs()) ||
              false;
            return (
              <div className="flex" key={passport.learningPathway.name}>
                <div className="edexlms-compliance-passport">
                  <div className="passport-title">
                    {passport.learningPathway.name}
                  </div>
                  <div className="passport-image">
                    <img
                      src={isExpired ? ExpiredPassportImage : PassportImage}
                      alt="compliance-passport"
                    />
                    <div className="passport-date">
                      {dayjs(passport.completionDate).format("DD MMM YYYY")}
                    </div>
                  </div>
                  {(passport.learningPathway.isRepetable && (
                    <div className="passport-validity">
                      Valid Until:{" "}
                      {dayjs(passport.completionDate)
                        .add(
                          passport.learningPathway.repetableInMonths,
                          "month"
                        )
                        .format("DD MMM YYYY")}
                    </div>
                  )) || <div className="passport-validity">&nbsp;</div>}
                </div>
              </div>
            );
          })}
        </div>
      )) || (
        <div>{intl.formatMessage({ id: "no_compliance_passport_data" })}</div>
      )}
    </Section>
  );
};

const mapStateToProps = (state) => ({
  compliancePassport: state.self?.compliancePassport || [],
});

const mapDispatchToProps = (dispatch) => ({
  compliancePassportRequest: () => dispatch(compliancePassportRequest()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompliancePassportWidget);
